import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { map } from "lodash";
import { Filter } from "lucide-react";

import classes from "./filter.module.scss";

import { UPDATE_FILTER } from "@/redux/types/auth.types";
import useFilterStore from "@/stores/useFilterStore";

import FilterEstateParent from "./FilterEstateParent";
import FilterEstate from "./FilterEstate";
import FilterSearch from "./components/FilterSearch";
import FilterCurrency from "./components/FilterCurrency";
import FilterUnitMeasurement from "./components/FilterUnitMeasurement";
import FilterApplyButton from "./components/FilterApplyButton";

const HeaderFilter = ({ openFilter, setOpenFilter }) => {
	const dispatch = useDispatch();
	const { user, filter } = useSelector((state) => state.auth);
	const { updateFilter } = useFilterStore();

	const { customer } = user || {};

	const [filterEstateParent, setFilterEstateParent] = useState([]);
	const [filterEstate, setFilterEstate] = useState([]);

	const refButton = useRef(null);
	const refDiv = useRef(null);

	const [search, setSearch] = useState(filter && filter.search);

	const changeEstateParentFilter = (select_filter) => {
		let localFilterEstate = [...filterEstate];
		let localFilter = [...filterEstateParent];
		if (select_filter === "ALL") {
			if (localFilter.length === map(user.estates_parents, "value").length) {
				localFilter = [];
				localFilterEstate = [];
			} else {
				localFilter = [...map(user.estates_parents, "value")];
				localFilterEstate = [...map(user.estates, "value")];
			}
		} else {
			const index = localFilter.indexOf(select_filter);
			const estates = user.estates.filter((item) => String(item.estate_parent_id) === String(select_filter));

			if (index > -1) {
				localFilterEstate = localFilterEstate.filter((item) => !estates.map((item) => item.value).includes(item));
				localFilter.splice(index, 1);
			} else {
				localFilter.push(select_filter);
				localFilterEstate = [...localFilterEstate, ...estates.map((item) => item.value)];
			}
		}

		localFilter = localFilter.filter((item) => Number(item) !== 0);

		setFilterEstateParent(localFilter);
		setFilterEstate(localFilterEstate);
	};

	const changeEstateFilter = (select_filter) => {
		let localFilter = [...filterEstate];
		if (select_filter === "ALL") {
			if (localFilter.length === map(user.estates, "value").length) {
				localFilter = [];
			} else {
				localFilter = [...map(user.estates, "value")];
			}
		} else {
			const index = localFilter.indexOf(select_filter);
			if (index > -1) {
				localFilter.splice(index, 1);
			} else {
				localFilter.push(select_filter);
			}
		}

		localFilter = localFilter.filter((item) => Number(item) !== 0);

		setFilterEstate(localFilter);
	};

	const applyFilter = () => {
		const newFilterEstateParent = filterEstateParent.filter((item) => Number(item) !== 0);
		const newFilterEstate = filterEstate.filter((item) => Number(item) !== 0);

		const newFilter = {
			...filter,
			estate_parent_id: newFilterEstateParent.toString(),
			estate_id: newFilterEstate.toString(),
		};

		dispatch({ type: UPDATE_FILTER, payload: { filter: newFilter } });
		updateFilter({ estate_parent_id: newFilterEstateParent.toString(), estate_id: newFilterEstate.toString() });

		setOpenFilter(false);
	};

	const handleClickOutside = (event) => {
		if (refButton.current && !refButton.current.contains(event.target) && refDiv.current && !refDiv.current.contains(event.target)) {
			setOpenFilter(false);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);

		setFilterEstate(
			filter.estate_id
				? String(filter.estate_id)
						.split(",")
						.map((element) => Number(element))
				: [],
		);
		setFilterEstateParent(
			filter.estate_parent_id
				? String(filter.estate_parent_id)
						.split(",")
						.map((element) => Number(element))
				: [],
		);
		// eslint-disable-next-line
	}, [filter]);

	return (
		<div className={classes.filterWrapper}>
			<Filter className={classes.iconFilter} onClick={() => setOpenFilter(!openFilter)} ref={refButton} strokeWidth={2} />

			<div className={`${classes.filter} ${openFilter ? classes.active : ""}`} ref={refDiv}>
				<h3>Filtrar por</h3>

				<FilterSearch filter={filter} search={search} setSearch={setSearch} setOpenFilter={setOpenFilter} />

				<FilterCurrency filter={filter} />

				<FilterUnitMeasurement filter={filter} />

				{customer && !!customer.use_estates_parents ? (
					<FilterEstateParent
						filterEstateParent={filterEstateParent}
						filterEstate={filterEstate}
						changeEstateParentFilter={changeEstateParentFilter}
						changeEstateFilter={changeEstateFilter}
					/>
				) : (
					<FilterEstate filterEstate={filterEstate} changeEstateFilter={changeEstateFilter} />
				)}

				<FilterApplyButton onClick={applyFilter} />
			</div>
		</div>
	);
};

export default HeaderFilter;
